import "@babel/polyfill";
import "core-js/stable";
import "core-js/es/array";

import "./utils/polyfills/find";

import Vue from "vue";
import VueMeta from "vue-meta";
import App from "./App.vue";
import store from "./store";
import router from "./router";

import api from "./api";

import "./styles/base.scss";

import SchoolTogetherUI from "./shared";

Vue.use(VueMeta);
Vue.config.productionTip = false;
Vue.prototype.$api = api;

new Vue({
    store,
    router,
    mixins: [SchoolTogetherUI],
    render: h => h(App)
}).$mount("#app");
